import React from 'react';
import './Features.css';
import previewVideo from './assets/preview.mp4';
import { Trans, useTranslation } from 'react-i18next';  // useTranslation hinzugefügt
import { GrShieldSecurity, GrNetwork, GrCpu } from "react-icons/gr";

const Features = () => {
  useTranslation();  // sorgt für Re-Render bei Sprachwechsel
  return (
    <div className="features-component" id="features">
      <div className="features-left">
        <video
          src={previewVideo}
          className="features-lock"
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
      <div className="features-right">
        <h2>
          <Trans
            i18nKey="features_heading"
            components={{ br: <br /> }}
          />
        </h2>
        <p>
          <Trans
            i18nKey="features_description"
            components={{ highlight: <span style={{ color: "#CAF881" }} /> }}
          />
        </p>
        
        {/* Feature boxes */}
        <div className="features-info-blocks">
          <div className="features-info-block">
            <GrShieldSecurity className="features-info-icon" />
            <div className="features-info-text">
              <p>Private builds that are individually encrypted.</p>
            </div>
          </div>
          <div className="features-info-block">
            <GrNetwork className="features-info-icon" />
            <div className="features-info-text">
              <p>No interaction with any game files, no injections!</p>
            </div>
          </div>
          <div className="features-info-block">
            <GrCpu className="features-info-icon" />
            <div className="features-info-text">
              <p>MAKCU Board performs recoil compensation.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
